import {Base64} from "js-base64";


/**
 * 编码
 * @param {*} str 
 * @returns 
 */
export function encode(str) {
    return Base64.encode(str);
}

/**
 * 获取当前时间
 * @returns 
 */
export function getCurrentTime() {
    const now = new Date();
    const year = now.getFullYear();
    const month = padNumber(now.getMonth() + 1);
    const day = padNumber(now.getDate());
    const hours = padNumber(now.getHours());
    const minutes = padNumber(now.getMinutes());
    const seconds = padNumber(now.getSeconds());
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}


function padNumber(num) {
    return num < 10 ? '0' + num : num;
}


/**
 * 校验手机号码
 * @param {*} phoneNumber 
 * @returns 
 */
export function validatePhoneNumber(phoneNumber) {
    const regex = /^1[3456789]\d{9}$/;
    return regex.test(phoneNumber);
}

/**
 * 格式化RMB
 * @param {*} amount 
 * @returns 
 */
export function formatRMB(amount) {
    if(amount == 0){
       return "0.00"; 
    }
    if(amount == null || amount == undefined){
        return "0.00"; 
    }
    if((typeof amount) == 'string'){
        amount = new Number(amount);
    }
    // 将数字转换为字符串
    let amountStr = amount.toFixed(2);
    // 分割小数点
    let parts = amountStr.split('.');
    let integerPart = parts[0];
    let decimalPart = parts[1] ? '.' + parts[1] : '';
    // 整数部分格式化
    let formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    // 返回格式化后的字符串
    return formattedInteger + decimalPart;
}


// WEBPACK FOOTER //
// ./src/utils/kits.js